// extracted by mini-css-extract-plugin
export default {"search":"style_search__VudqS"};